import React, { useState, useEffect } from 'react';
import { FiPrinter, FiInfo, FiArrowLeft } from 'react-icons/fi';
import config from '../../config/config';
import { useLocation, useNavigate } from 'react-router-dom';

export function DeliveryPrint() {


}